
import { Component, OnInit, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ContractService } from '../../services/contract.service';
import { Router } from '@angular/router';
import { ModalComponent } from '../../shared-components/modal/modal.component';
import { AdminService } from '../../services/Admin.service';
import { userProfile } from '../../models/userProfile';
import { DataService } from './../../services/data.service';
import { Title } from '@angular/platform-browser';
import { TransientTypes } from '../../models/TransientTypes';

@Component({
  selector: 'app-myjssi-bundle',
  templateUrl: './myjssi-bundle.component.html',
  styleUrls: ['./myjssi-bundle.component.scss']
})
export class MyjssiBundleComponent implements OnInit {
  transientTypes = TransientTypes;
  currentTransientType: TransientTypes = TransientTypes.cdd;
  currentTransientUrl: string;
  loading: Boolean = false;
  @ViewChild('popup') popup: ModalComponent;
  public user: userProfile;
  public userInfo: any;
  public name = '';
  externalUrl: string;
  public header: string;
  public card: any[] = [
    {
      titleUp: "MAINTENANCE",
      titleDown: "PROGRAMS",
      content: "Report flight hours, view and pay JSSI invoices, and contact your dedicated Hourly Cost Maintenance support team.",
      backgroundColor: "#001f4e",
      imageUrl: "assets/icons/icon-hcm-background.svg",
      onClickTriggered: () => this._router.navigate(['/pages/client/my-contracts'])
    },
    {
      titleUp: "PARTS &",
      titleDown: "LEASING",
      content: "Request a part online for assets not covered by JSSI. Your procurement team is standing by to rapidly quote or source the quality parts you need.",
      backgroundColor: "#52a0e2",
      imageUrl: "assets/icons/icon-parts-background.svg",
      onClickTriggered: () => this.onSwitchButtonClick('5cd40868-9374-4820-8a1a-52a956507eb3', this.transientTypes.partsportal)
    },
    {
      titleUp: "ADVISORY",
      titleDown: "SERVICES",
      content: "Arrange an asset inspection or appraisal from an ASA-accredited appraiser. Explore a range of consulting and maintenance event management services.",
      backgroundColor: "#3a567c",
      imageUrl: "assets/icons/icon-handshake.svg",
      onClickTriggered: () => this._router.navigate(['/pages/advisoryservices'])
    },
    {
      titleUp: "VENDOR INVOICING",
      titleDown: "& PAYMENTS",
      content: "Submit aircraft maintenance and parts vendor invoices and view payment status.",
      backgroundColor: "#001f4e",
      imageUrl: "assets/icons/icon-hcm-background.svg",
      onClickTriggered: () => this._router.navigate(['/pages/vendor/myvendor'])
    },
    {
      titleUp: "Aircraft Operating Cost",
      titleDown: "& Performance Guide",
      content: "Compare and benchmark aircraft operating costs and performance. Make fully informed ownership and operating decisions with the most trusted aircraft data available.",
      backgroundColor: "#0B233F",
      imageUrl: "assets/icons/icon-conklin-background.svg",
      onClickTriggered: () => this.onSwitchButtonClick('99f2df69-629e-4d82-8732-5e27151c2b92', this.transientTypes.cdd)
    },
    {
      titleUp: "STATE TAX",
      titleDown: "GUIDE",
      content: "Access the latest critical aviation tax information for all 50 U.S. states in one convenient place.",
      backgroundColor: "#0B233F",
      imageUrl: "assets/icons/icon-hcm-background.svg",
      onClickTriggered: () => this.onSwitchButtonClick('99f2df69-629e-4d82-8732-5e27151c2b92', this.transientTypes.cdd)
    },
  ];
  constructor(private _authService: AuthService,
    private _router: Router,
    private adminSVC: AdminService,
    private contractSvc: ContractService,
    private dataSvc: DataService,
    private titleSvc: Title
  ) { }

  ngOnInit() {
    this.userInfo = this.dataSvc.userDisplayInfo;
    console.log(this.userInfo);
     this.name = this.userInfo.FirstName + ' ' + this.userInfo.LastName;
  }

  onSwitchButtonClick(destinationAppId: string, transientType: TransientTypes) {
    console.log('inside swtich button');
    this.loading = false;
    if (this.dataSvc.userDisplayInfo.UserTypeID === 5) {
      this._authService.getImpersonateMYJSSIuser(this.dataSvc.userDisplayInfo.id,
        this.dataSvc.userDisplayInfo.adminbearerToken, this.dataSvc.userDisplayInfo.Email)
        .subscribe(
          url => {
            console.log('URL', url);

          //  this.authService.logOut();
            window.open(url, '_blank');
          }
        );
    } else {
    this.currentTransientType = transientType;
    if (!this.loading) {
      this.loading = true;
      console.log('this.dataService.userDisplayInfo.id', JSON.stringify(this.dataSvc.userDisplayInfo));

      this._authService.getTransientUrl(this.dataSvc.userDisplayInfo.id, destinationAppId,
        this.dataSvc.userDisplayInfo.bearerToken)
        .subscribe(
          url => {
            console.log('URL', url);
            this.currentTransientUrl = url;
             this.externalUrl=url;
            const urlSplits = url.split('?');
            if (urlSplits.length > 1) {
              const paramString = urlSplits[1];
              const queryString = new URLSearchParams(paramString);
              const authToken = queryString.get('token');
              if (authToken == null) {
                location.href = url;
              }
              const firstTimeLoggingIn = authToken.split('^')[1];
              if (firstTimeLoggingIn === '1') {
                this.popup.show();

              } else {

                this._authService.logOut();
                location.href = url;

                // console.log(url);

              }
            } else {

              this._authService.logOut();
              location.href = url;

              // console.log(url);

            }
          }

        );
    }
  }
    return false;
  }


  navigateToOtherSite(url: string) {
    this._authService.logOut();
    location.href = this.externalUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/myjssi-bundle/myjssi-bundle.component.ts